export enum SystemEnvironment {
  STAGING = 'stg',
  PRODUCTION = 'prd',
}
